/**
 * Access Control API service
 * User access is action-level, same sections as role access.
 */
import axiosInstance from './AxiosInstance';
import { rememberSessionAccess } from '../utils/roleAccess';

const BASE = '/access-control';

export const accessControlService = {
  getMyAccess: () => axiosInstance.get(`${BASE}/my-access`).then((res) => {
    if (res?.data?.success) rememberSessionAccess(res.data.data);
    return res;
  }),
  getMenuSections: () => axiosInstance.get(`${BASE}/menu-sections`),
  getActionCatalog: () => axiosInstance.get(`${BASE}/action-catalog`),
  getRoleAccess: (roleId) => axiosInstance.get(`${BASE}/role/${roleId}`),
  getUserAccess: (corporateUserId) => axiosInstance.get(`${BASE}/user/${corporateUserId}`),
  saveUserAccess: (corporateUserId, { sections, fullAccess }) =>
    axiosInstance.put(`${BASE}/user/${corporateUserId}`, { sections, fullAccess }),
};
